import {create} from "zustand";

type SessionStore = {
  session_remaining_seconds: number | null;
  setSessionRemainingSeconds: (seconds: number) => void;
  decrementSessionRemainingSeconds: () => void;
};

const useSessionStore = create<SessionStore>()((set) => ({
  session_remaining_seconds: 5 * 60,
  setSessionRemainingSeconds: (seconds) =>
    set({session_remaining_seconds: seconds}),
  decrementSessionRemainingSeconds: () =>
    set((state) => ({
      session_remaining_seconds: Math.max(
        0,
        state.session_remaining_seconds
          ? state.session_remaining_seconds - 1
          : 0,
      ),
    })),
}));

export {useSessionStore};
